// @generated by tools/docgen — do not edit.
// Source: docs/examples/scalar_list.md

import React from 'react';
import { ScalarListDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function ScalarListPage() {
  return (
    <ExampleLayout title="Reactive list of scalars" demo={<ScalarListDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          This example demonstrates rx[list[str]]: a reactive list field mutated in place with ordinary Python list methods. Every append, insert, __setitem__, del, pop and reassignment sends a small positional delta to the client instead of re-sending the whole list, however many items it holds.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-scalar-list-backend">
        <ExampleSectionHeading id="examples-scalar-list-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="scalar_list/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-scalar-list-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-scalar-list-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="scalar_list/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default ScalarListPage;
